import MapImg from "../../assets/images/webp/careers/omniMapImg.webp";
import Collapsible from "react-collapsible";

import CONSTANTS from "../../utils/constants/CONSTANTS";

import "./index.scss";

const CoreValues = () => {
  return (
    <div className="corevalues-section">
      <div className="left">
        <div className="title">Core Values</div>
        <div className="description para">
          Omni-Active® operates with everything tying back to our common goal: creating an IMPACT in the world.
        </div>
        <div className="description">
          • <strong> I</strong>ntegrity- we are always committed to doing the right thing.
        </div>
        <div className="description">
          • <strong>M</strong>otivation- we strive to encourage clients to maintain effort to achieve their goals.
        </div>
        <div className="description">
          • <strong>P</strong>assion- client success and love for our industry is our constant driver.
        </div>
        <div className="description">
          • <strong>A</strong>ccountability- personal responsibility for actions is a top priority.
        </div>
        <div className="description">
          • <strong>C</strong>ommitment- we are committed to personal growth and with that, growth of others.
        </div>
        <div className="description">
          • <strong>T</strong>eamwork- fitness is always a team effort, both internally and with our community.
        </div>
        <div className="small-line" />
        {CONSTANTS.companyInfo.map((value) => (
          <div key={value.id} className="collapsible-fields">
            <Collapsible trigger={<div className="collapsible-title">{value.title}</div>} transitionTime={200}>
              <div className="description"> {value.Description}</div>
            </Collapsible>
            <div className="small-line" />
          </div>
        ))}
      </div>
      <div className="right">
        <img className="image" src={MapImg} alt="location img" />
        <div className="text">Cleveland, OH - San Antonio, TX - West Palm Beach, FL - Seattle, WA</div>
      </div>
    </div>
  );
};

export default CoreValues;
